module.exports = __webpack_public_path__ + "media/images/patient-icons/arrow-up-3b00a32837b01b63321df0d0f92484bb.svg";